// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { auth as authStore } from 'lib/auth'
import * as AuthApi from 'api/auth'
import { setAPIAuthHeader, clearAPIAuthHeader } from 'api'
import { setServiceId } from '../constants'
import { message } from 'antd'

export const auth = {
  state: {
    userInfo: authStore.getUser(),
    isAuthorized: authStore.isAuthorized(),
    loading: false
  },
  reducers: {
    setLoading (state, payload) {
      return {
        ...state,
        loading: payload
      }
    },
    loginSuccess: (state, payload) => ({
      ...state,
      isAuthorized: true,
      loading: false
    }),
    setUserInfo: (state, userInfo) => ({
      ...state,
      userInfo
    }),
    clearLoginInfo: state => ({
      userInfo: null,
      isAuthorized: false,
      loading: false,
    })
  },
  effects: dispatch => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async loginAsync (googleOAuthResponse, rootState) {
      dispatch.auth.setLoading(true)
      try {
        const res = await AuthApi.login({
          oauth_provider: 'google',
          oauth_token: googleOAuthResponse.accessToken,
          app_source: 'cmt_portal',
        })
        authStore.setToken(res.accessToken)
        authStore.setRefreshToken(res.refreshToken)
        setAPIAuthHeader(authStore.getToken())
        const userInfo = {
          ...res.userInfo,
          google: googleOAuthResponse.profileObj
        }
        authStore.setUser(userInfo)
        dispatch.auth.setUserInfo(userInfo)
        dispatch.auth.loginSuccess()
        dispatch.rbacCurrent.replaceRoles(userInfo.roleList || [])
        await dispatch.city.fetchCityList({ silence: true })
        // setServiceId(userInfo.service_id)
      } catch (error) {
        message.error(error.toString())
      }
    },
    async fetchUserInfo (payload, rootState) {
      const { userInfo } = rootState.auth
      try {
        const userRes = await AuthApi.getCurrentUser()
        const user = {
          ...userInfo,
          ...userRes.data
        }
        dispatch.auth.setUserInfo(user)
        authStore.setUser(user)
      } catch (error) {
        console.log(error.toString())
      }
    },
    invalidToken (token, rootState) {
      authStore.clear()
      dispatch.auth.clearLoginInfo()
      dispatch.rbacCurrent.clear()
      clearAPIAuthHeader()
    },
    async logOut (payload, rootState) {
      try {
        await AuthApi.logout({
          access_token: authStore.getToken(),
          refresh_token: authStore.getRefreshToken()
        })
      } catch (error) {
        message.error(error.toString())
      } finally {
        authStore.clear()
        dispatch.auth.clearLoginInfo()
        dispatch.rbacCurrent.clear()
        clearAPIAuthHeader()
      }
    }
  })
}
